const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20manhwa%20scene%20illustration%2C%20couple%20in%20cafe%20with%20warm%20sunlight%2C%20Korean%20webtoon%20art%20style%2C%20soft%20coral%20and%20cream%20color%20palette%2C%20beautiful%20detailed%20background%2C%20tender%20moment%2C%20cinematic%20composition&width=800&height=500&seq=media-manga-01&orientation=landscape',
    title: '社内相亲 · 甜蜜名场面合集',
    desc: '社长与职员的浪漫高光时刻',
    tag: '恋爱',
    views: '86.3万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20battle%20manhwa%20scene%2C%20hunter%20fighting%20giant%20monster%2C%20Korean%20webtoon%20style%2C%20dramatic%20lighting%2C%20dynamic%20action%20pose%2C%20warm%20dark%20tones%2C%20cinematic%20wide%20shot&width=800&height=500&seq=media-manga-02&orientation=landscape',
    title: '我独自升级 · 济州岛决战',
    desc: '影之军团全员出击燃炸全场',
    tag: '奇幻',
    views: '72.1万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20high%20school%20scene%20manhwa%2C%20girl%20transformation%20moment%2C%20Korean%20webtoon%20art%2C%20bright%20cheerful%20lighting%2C%20soft%20warm%20colors%2C%20youthful%20energy%2C%20cinematic%20composition&width=800&height=500&seq=media-manga-03&orientation=landscape',
    title: '女神降临 · 化妆变身全记录',
    desc: '从自卑到自信的校园逆袭之路',
    tag: '校园',
    views: '65.8万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Funny%20family%20comedy%20manga%20scene%2C%20spy%20family%20having%20dinner%2C%20Japanese%20manga%20style%2C%20warm%20home%20atmosphere%2C%20soft%20lighting%2C%20heartwarming%20moment%2C%20detailed%20background&width=800&height=500&seq=media-manga-04&orientation=landscape',
    title: '间谍过家家 · 福杰家日常',
    desc: '伪装家庭的温馨搞笑生活片段',
    tag: '喜剧',
    views: '58.4万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Fairy%20tale%20palace%20manhwa%20scene%2C%20beautiful%20princess%20in%20royal%20garden%2C%20Korean%20webtoon%20style%2C%20dreamy%20atmosphere%2C%20soft%20golden%20light%2C%20elegant%20composition%2C%20cinematic%20wide%20angle&width=800&height=500&seq=media-manga-05&orientation=landscape',
    title: '某天成为公主 · 皇宫名场面',
    desc: '穿越公主的华丽宫廷冒险之旅',
    tag: '穿越',
    views: '51.2万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">热门作品</h2>
          <p className="text-sm text-foreground-500 mt-2">女神漫画下拉式平台人气作品精选展示</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group cursor-pointer rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-background-50/80 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-primary-500 group-hover:text-background-50 text-lg ml-0.5 transition-colors"></i>
                  </div>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-background-50/80 text-foreground-700 whitespace-nowrap">
                    {item.views} 次观看
                  </span>
                </div>
              </div>
              <div className="p-3">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm font-heading text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}